

import { Button } from '@/components/ui/button';
import { Info } from 'lucide-react';

interface EmptyTechniquesProps {
  onClearFilters: (e: React.MouseEvent) => void;
}

export const EmptyTechniques: React.FC<EmptyTechniquesProps> = ({ onClearFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="bg-primary/10 p-3 rounded-full mb-4">
        <Info className="h-6 w-6 text-primary" />
      </div>
      <h3 className="text-lg font-medium mb-2">No techniques found</h3>
      <p className="text-muted-foreground max-w-md mb-4">
        We couldn't find any techniques matching your filters. Try adjusting your search criteria or clear the filters.
      </p>
      <Button 
        variant="outline" 
        onClick={onClearFilters}
        type="button"
      >
        Clear Filters
      </Button>
    </div>
  );
};
